import React, { useCallback, useState } from 'react';
import { Modal, Checkbox, Button } from 'antd'
import { goLogin } from './exportUtil'

const ProtocolModal = (props: any) => {
  // const { visible, onSign } = props

  const [visible, setVisible] = useState(true)
  // const onChange = useCallback((e) => {
  //   setChecked(e.target.checked)
  // }, [])

  // const onClick = useCallback(() => {
  //   if (checked) {
  //     vmsService.signedAgreement().then(() => {
  //       if (typeof onSign === 'function') {
  //         onSign()
  //       }
  //     })
  //   }
  // }, [checked, onSign])

  const onOk = useCallback(() => {
    if (typeof goLogin === 'function') {
      goLogin()
    }
  }, [goLogin])

  const onClose = useCallback(() => {
    setVisible(false)
  }, [])

  return (
    <Modal
      visible={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      width={480}
      getContainer={false}
    >
      <div className="star-protocol-modal star-base-modal">
        <div className="title">温馨提示</div>
        <div className="text">
          <div><span className="span"></span>亲爱的用户，欢迎使用星源产品！在产品使用之前，请先充分阅读<a className="link" href="/user-protocol" target="_blank">《用户服务协议》</a>和<a className="link" href="/privacy-protocol" target="_blank">《隐私政策》</a>。</div>
          <div><span className="span"></span>点击同意即代表您已阅读并同意<a className="link" href="/user-protocol" target="_blank">《用户服务协议》</a>和<a className="link" href="/privacy-protocol" target="_blank">《隐私政策》</a>。如果您不同意，将可能影响使用星源的产品和服务。</div>
        </div>
        {/* <div className="box">
          <Checkbox onChange={onChange}>我已阅读并同意星源<a className="link" href="/user-protocol" target="_blank">《用户服务协议》</a>和<a className="link" href="/privacy-protocol" target="_blank">《隐私政策》</a></Checkbox>
        </div> */}
        <div className="btn-area">
          <Button onClick={onClose}>不同意</Button>
          <Button type="primary" onClick={onOk}>同意</Button>
        </div>
      </div>
    </Modal>
  )
}


export default React.memo(ProtocolModal);